<template>
  <footer class="footer" role="contentinfo">
    <router-link class="footer__logo" :to="{ name: 'home', params: { lang: $i18n.locale }}">
      <svg class="icon-logo" xmlns="http://www.w3.org/2000/svg" width="400" height="304.117" viewBox="0 0 400 304.117">
        <path
          d="M555.457-188.369H507.516c0,47.775-18.51,76.951-69.093,100.049V-188.369H390.187V-70.7s-24.794,7.069-38.873,10.544h-.029q-15.853,3.824-30.574,8V-188.369h-48.23V-36c-74.274,29.539-117.024,73.5-117.024,151.745h47.936c0-47.775,18.5-76.951,69.088-100.044V115.748h48.23V-1.918c11.887-3.574,24.8-7.069,38.887-10.544h.025q15.853-3.824,30.564-8V115.748h48.235V-36.619c74.279-29.544,117.034-73.5,117.034-151.75"
          transform="translate(-155.457 188.369)"
          fill="#fff"/>
      </svg>

    </router-link>
    <ul class="footer__list">
      <li>
        <a class="footer__item" :href="$t('footer_menu_newsletter_link')">
           {{ $t("footer_menu_newsletter") }}
        </a>
      </li>
      <li>
        <a class="footer__item" :href="$t('footer_menu_jobs_link')">
           {{ $t("footer_menu_jobs") }}
        </a>
      </li>
      <li>
        <a class="footer__item" :href="$t('footer_menu_press_link')">
           {{ $t("footer_menu_press") }}
        </a>
      </li>
      <li>
        <a class="footer__item" :href="$t('footer_menu_contactus_link')">
           {{ $t("footer_menu_contactus") }}
        </a>
      </li>
      <li>
        <a class="footer__item" :href="$t('footer_menu_services_link')">
           {{ $t("footer_menu_services") }}
        </a>
      </li>
      <li>
        <a class="footer__item" :href="$t('footer_menu_trackorder_link')">
           {{ $t("footer_menu_trackorder") }}
        </a>
      </li>
      <li>
        <a class="footer__item" :href="$t('footer_menu_privacy_link')">
           {{ $t("footer_menu_privacy") }}
        </a>
      </li>
      <li>
        <a class="footer__item" :href="$t('footer_menu_legalnotice_link')">
           {{ $t("footer_menu_legalnotice") }}
        </a>
      </li>
      <li>
        <a class="footer__item" :href="$t('footer_menu_websiteterms_link')">
           {{ $t("footer_menu_websiteterms") }}
        </a>
      </li>
      <li>
        <a class="footer__item" :href="$t('footer_menu_msa_link')">
           {{ $t("footer_menu_msa") }}
        </a>
      </li>
    </ul>
    <ul class="footer__market_nav">
      <li class="footer__market_item">
        <select class="footer__market_selector" v-model="$i18n.locale" :aria-label="$t('global_language_selector_alt')">
          <option value="en">{{ $t('footer_language_en') }}</option>
          <option value="fr">{{ $t('footer_language_fr') }}</option>
        </select>
      </li>
    </ul>
    <ul class="footer__social">
      <li>
        <a :href="$t('footer_social_facebook_link')">
          <svg class="icon-footer">
            <title>{{ $t('footer_social_facebook_alt') }}</title>
            <use xlink:href="@/assets/symbols.svg#facebook"></use>
          </svg>
        </a>
      </li>
      <li>
        <a :href="$t('footer_social_instagram_link')">
          <svg class="icon-footer">
            <title>{{ $t('footer_social_instagram_alt') }}</title>
            <use xlink:href="@/assets/symbols.svg#instagram"></use>
          </svg>
        </a>
      </li>
      <li>
        <a :href="$t('footer_social_pinterest_link')">
          <svg class="icon-footer">
            <title>{{ $t('footer_social_pinterest_alt') }}</title>
            <use xlink:href="@/assets/symbols.svg#pinterest"></use>
          </svg>
        </a>
      </li>
      <li>
        <a :href="$t('footer_social_twitter_link')">
          <svg class="icon-footer">
            <title>{{ $t('footer_social_twitter_alt') }}</title>
            <use xlink:href="@/assets/symbols.svg#twitter"></use>
          </svg>
        </a>
      </li>
      <li>
        <a :href="$t('footer_social_weibo_link')">
          <svg class="icon-footer">
            <title>{{ $t('footer_social_weibo_alt') }}</title>
            <use xlink:href="@/assets/symbols.svg#weibo"></use>
          </svg>
        </a>
      </li>
      <li>
        <a :href="$t('footer_social_youtube_link')">
          <svg class="icon-footer">
            <title>{{ $t('footer_social_youtube_alt') }}</title>
            <use xlink:href="@/assets/symbols.svg#youtube"></use>
          </svg>
        </a>
      </li>
    </ul>
    <div class="footer__copyright">
      {{ $t("footer_copyright", {year: year}) }}
    </div>
  </footer>
</template>

<script>
export default {
  name: 'C-Footer',
  computed: {
    year () {
      const d = new Date()
      return d.getFullYear()
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';

.footer {
  padding: 4rem 2rem 10rem 2rem;
  @media screen and (min-width: 1400px) {
    padding: 8rem 2rem 10rem 2rem;
    margin-top: 8rem;
  }
  text-align: center;
  background: $c-bg-footer;
  &__copyright {
    color: $c-txt-footer;
    font-family: $ff-galaxieitalic-400;
    font-size: 1.4rem;
    line-height: 2.4rem;
    max-width: calc(66.66667% - 7px);
    margin: auto;
  }
  &__logo {
    display: block;
    margin-bottom: 30px;
    @media screen and (min-width: $mq-medium) {
      margin-bottom: 80px;
    }
    .icon-logo {
      width: 46px;
      height: 35px;
      fill: white;
    }
  }
  &__list {
    display: flex;
    list-style: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 1rem 0 1.5rem;
    li{
      position: relative;
      padding-bottom: 35px;
      &:last-child{
        margin-right: 0px;
      }
    }
    @media screen and (min-width: $mq-medium) {
      flex-direction: row;
      padding: 0 0 1.5rem;
      li{
        margin-right: 30px;
        margin-bottom: 0;
        padding-bottom: 0;
        position: relative;
        max-width: 150px;
        &:last-child{
          margin-right: 0px;
          &:after{
            display: none;
          }
        }
        &:after{
          position: absolute;
          right: -15px;
          bottom: calc(50% + 8px);
          width: 1px;
          height: 1px;
          color: #fff;
          content: "\B7";
        }
      }
    }
  }
  &__market_nav {
    display: flex;
    list-style: none;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin: 0;
    padding: 0 0 8rem;
    @media screen and (min-width: $mq-medium) {
      padding: 0 0 4.5rem;
    }
  }
  &__item {
    font-family: $ff-gotham-700;
    text-decoration: none;
    text-transform: uppercase;
    color: #ffffff;
    font-size: 1rem;
    padding: 0;
    letter-spacing: 2px;
    position: relative;
    text-align: center;
    line-height: 1.2;
    display: block;
    &:hover {
      &:before{
        transition: width .5s;
        width: 100%;
      }
    }
    &:before{
      position: absolute;
      bottom: -3px;
      left: 0;
      display: block;
      width: 0;
      height: 1px;
      content: "";
      background-color: #fff;
    }
  }
  &__market_item {
    position: relative;
    select {
      @include select-css(
        $bgColor: $c-bg-footer,
        $textColor: #fff,
      );
      font-size: 1rem;
      text-transform: uppercase;
      font-family: $ff-gotham-500;
      letter-spacing: 2px;
      border: 0;
      padding-right: 2rem;
      option {
        font-size: 1.6rem;
      }
    }
    .icon-select {
      position: absolute;
      right:0;
      top: 5px;
      width: 8px;
      height: 6px;
      stroke-width: 6px;
      fill: #dc3034;
      transform: rotate(0.25turn);
    }
  }
  &__social {
    display: flex;
    list-style: none;
    justify-content: center;
    margin: 0 auto 8rem;
    @media screen and (min-width: $mq-medium) {
      margin: 0 auto 2.5rem;
    }
    padding: 0;
    li {
      padding: 0 1.5rem;
      @media screen and (min-width: $mq-medium) {
        padding: 0 2.25rem;
      }
    }
    a {
      color: #ffffff;
      width: 25px;
      display: inline-block;
    }
    .icon-footer {
      width: 16px;
      height: 16px;
      fill: currentColor;
    }
  }
}
</style>
